// extracted by mini-css-extract-plugin
export var divider = "_gg-7";
export var itemsToggle = "_gg-8";
export var mergeModal = "_gg-1";
export var optionCard = "_gg-4";
export var radioGroup = "_gg-6";
export var radioOption = "_gg-0";
export var selected = "_gg-5";
export var shipmentOptions = "_gg-2";
export var tableOptions = "_gg-3";